import styles from "./index.module.css";
import PropTypes from "prop-types";

/**
 * Displays a sticky-note-like card with information the user should be aware of. Title is optional.
 */
export default function AlertNotice({ icon, title, children }) {
  return (
    <div className={styles.notice}>
      {title && (
        <header>
          {icon && <div className={styles.noticeIcon}>{icon}</div>}
          <span className={styles.noticeTitle}>{title}</span>
        </header>
      )}
      <div className={styles.noticeBody}>{children}</div>
    </div>
  );
}

AlertNotice.propTypes = {
  /**
   * Optional title to display inside the notice.
   */
  title: PropTypes.string,
  /**
   * Optional icon, only displayed with title.
   */
  icon: PropTypes.node,
};
